export function Footer() {
  return (
    <footer className="footer">
      <div className="shell">
        <span>© {new Date().getFullYear()} YoGo Studio · 免付费 · 零广告 · 源文件不上传</span>
        <span className="spacer" />
        <span>转换记录只保存元数据与缩略图，可随时清空</span>
      </div>
    </footer>
  );
}
